<header>
  <h4>{{ 'content.availability.header' | translate }}</h4>
  @defer (when !loading()) {
    @for (disponibility of disponibilities(); track $index) {
      <app-chip
        [text]="disponibility.label"
        [icon]="disponibility.icon"
        [isCrossedOut]="!!disponibility.disabled"
      />
    }
    <kin-icon
      name="information"
      [color]="colorService.brandSecondary400()"
      [tooltip]="'content.availability.tooltip.info' | translate"
      tooltipPosition="top"
    />
    @if (isExpandable()) {
      <button class="toggle-button" type="button" (click)="toggleIsOpen()">
        <kin-icon [name]="isOpen() ? 'arrow_top' : 'arrow_bottom'" />
      </button>
    }
  } @placeholder {
    <kin-skeleton [width]="7" [height]="2" [borderRadius]="50" />
    <kin-skeleton [width]="7" [height]="2" [borderRadius]="50" />
    <kin-skeleton [width]="1.5" [height]="1.5" [borderRadius]="50" />
  }
</header>

@if (isOpen()) {
  <div class="details u-fade-slide-in">
    <p>{{ 'content.availability.criteria_intro' | translate }}</p>
    <div class="criteria">
      @if (moderationReasons() === undefined) {
        @for (i of [].constructor(7); track $index) {
          <kin-skeleton [width]="10" [height]="2" [borderRadius]="50" />
        }
      } @else {
        @for (moderationReason of moderationReasons(); track $index) {
          <app-chip
            [class.hidden]="moderationReason.id === 8 && getReasonStatus(moderationReason.id)"
            [backgroundColor]="
              getReasonStatus(moderationReason.id)
                ? colorService.success100()
                : colorService.danger100()
            "
            [color]="colorService.neutral900()"
            iconColor="white"
            [iconBackground]="
              getReasonStatus(moderationReason.id)
                ? colorService.success()
                : colorService.danger500()
            "
            [icon]="getReasonStatus(moderationReason.id) ? 'g_validate' : 'close'"
            [text]="'content.availability.' + moderationReason.reason + '.label'"
          />
        }
      }
    </div>
    @for (moderationReason of moderationRefusedReasons(); track $index) {
      <div class="reason">
        <kin-icon name="align_right" [size]="32" [color]="colorService.neutral600()" />
        <p class="description">
          {{
            moderationReason.custom_comment ??
              `content.availability.${moderationReason.reason}.refusal_reason` | translate
          }}
        </p>
        <span class="author">Romain, modérateur Kinomap</span>
      </div>
    }
  </div>
}
